import AuthenticationService from '.';
import ReactSubscribable from './base/ReactSubscribable';
import EndpointService from '../../HTTP/EndpointService';

import { AUTHENTICATION_SERVER_URL } from '../../configuration';
import { setStorage, getStorage } from './utils/storage';




class TOTPService extends ReactSubscribable {

    authenticationServer = AUTHENTICATION_SERVER_URL;
    authenticationToken = '';
    reactSubscribers = [];
    tokenEmailSend = 0;


    constructor() {
        super();
        this.tokenEmailSend = Number(getStorage('totp_email_sent') || 0);
        this.state.tokenEmailSend = this.tokenEmailSend;
    }

    async getQRCode() {
        let response = EndpointService.post(AUTHENTICATION_SERVER_URL + '/api/generate-qr-code', {});
        return response;
    }

    async checkQRCode({ otp }) {
        let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/api/generate-qr-check', { otp });
        if(!response.error) {
            console.log("no error in response");
            console.log("contents of response", response);
            AuthenticationService.processSuccessfullAuthenticationResponse({data:response});
        }
        return response;
    }

    async sendTokenEmailManually() {
        let response = await EndpointService.get(AUTHENTICATION_SERVER_URL + '/api/request-totp-email');
        if(response.error) {
            console.log("error in response", response);
        }
    }
    
    async sendTokenEmail() {
        if(this.tokenEmailSend + 1000 * 60 * 5 < Date.now()) {
            let response = await EndpointService.get(AUTHENTICATION_SERVER_URL + '/api/request-totp-email');
            if(response.error) {
                console.log("error in response", response);
            } else {
                this.tokenEmailSend = Date.now();
                setStorage('totp_email_sent', this.tokenEmailSend);
                this.updateState({ tokenEmailSend: this.tokenEmailSend });
            }

        }
        return false;
    }

    async checkRememberedTOTP() {
        let tokens = await AuthenticationService.getTokens();
        if(tokens && tokens.length > 0) {
            let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/api/totp-remember-check', {
                rememberTokens: tokens
            });
            if(response.error) {
                console.log("error in response", response);
            } else {
                AuthenticationService.processSuccessfullAuthenticationResponse({data:response});
            }
        }
    }

    async hasRememberedTOTP() {
        let tokens = await AuthenticationService.getTokens();
        if(tokens && tokens.length > 0) {
            let hasRememberedTOTP = tokens.some(token => token.t == 'totp-remember' && token.exp > Date.now());
            return hasRememberedTOTP;
        }
        return false;
    }

    async checkTotpCode({ code, remember }) {
        try {
            let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/api/totp-check', {
                code,
                remember
            });

            if(response && response.error) {
                this.updateState({ errorMessage: response.error == 'INVALID_TOTP' ? 'Ongeldige 2FA code' : ''});
            } 
            AuthenticationService.processSuccessfullAuthenticationResponse({data:response});
            return true;
        } catch (e) {

            // console.log("error in checkTotpCode", e);

            if(e && e.error) {
                this.updateState({ errorMessage: e.error == 'INVALID_TOTP' ? 'Ongeldige 2FA code' : ''});
            } else {
                this.updateState({ error: e.message, errorMessage: null });
            }
        }
    }

    async confirmChallenge() {
        let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/api/confirm-challenge', {});
        if(response.error) {
            console.log("challenge failed");
        } else {
            AuthenticationService.processSuccessfullAuthenticationResponse({data:response});
        }
    }

}

export default new TOTPService();